import React from "react";
import { useParams } from "react-router-dom";
import WayfinderLayout from "./WayfinderLayout";
import MapSettings from "./MapSettings";

const MapPage = ({ buttonColor }) => {
  const { userId } = useParams();
  return <MapSettings userId={userId} buttonColor={buttonColor} />;
};

// Wrap with layout
const MapPageWithLayout = () => (
  <WayfinderLayout>
    <MapPage />
  </WayfinderLayout>
);

export default MapPageWithLayout;
